<template>
  <div>
  <div
    v-cloak
    v-if="brandSlug === 'BH1'"
    class="header-wrapper-bhx"
    :style="set_style_variables"
  >
    <div class="header-inner" :class="page_classes">
      <div
        @click="gotoPage(logo_link.url, logo_link.mtype)"
        class="ID-logo"
      ></div>
      <div>
        <div class="bhx-links">
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/arrivals-and-departures/"
            ><i class="icon icon--arrivals-departures"></i>Arrivals and
            Departures</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/airport-parking/"
            ><i class="icon icon--parking"></i>Parking</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/directions-and-transport/"
            ><i class="icon icon--directions-transport"></i>Directions and
            Transport</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/at-the-airport/"
            ><i class="icon icon--airport"></i>At the Airport</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/destinations-and-more/"
            ><i class="icon icon--destintinations-and-more"></i>Destinations
            &amp; More</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/at-the-airport/terminal-facilities/assisted-travel/"
            ><i class="icon icon--special-assistance"></i>Assisted Travel</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/search/"
            class="bhx-search"
            ><i class="icon icon--search"></i>Search</a
          >
        </div>
      </div>
    </div>
  </div>

  <!-- <div
    v-cloak
    v-if="brandSlug === 'LAX'"
    class="header-wrapper header-wrapper-hello-msg"
    :style="set_style_variables"
    style="width: 100%"
  >
    <div class="header-inner">
      <div class="menu-items-wrapper">
        <span class="hello-msg">We have upgraded our booking platform. Need Help? <a href="https://parking.flylax.com/lax-newbookingsite.html" target="_blank">Click here</a></span>
      </div>
    </div>
  </div> -->

  <div
    v-cloak
    v-if="brandSlug === 'RDU'"
    class="header-wrapper header-wrapper-hello-msg header-wrapper-hello-msg-rdu"
    :class="page_classes"
    :style="set_style_variables"
    style="width: 100%"
  >
    <div class="header-inner">
      <div class="menu-items-wrapper">
        <span class="hello-msg">{{ getBrandText('realIdMessage', 'A REAL ID or other approved ID is now required to fly.') }} <a :href="getBrandText('realIdUrl', 'https://www.dhs.gov/real-id')" target="_blank">{{ getBrandText('realIdLinkText', 'www.dhs.gov/real-id') }}</a></span>
      </div>
    </div>
  </div>

  <!-- <div
    v-cloak
    v-if="brandSlug === 'SB4'"
    class="header-wrapper header-wrapper-hello-msg header-wrapper-hello-msg-sb2"
    :style="set_style_variables"
    style="width: 100%;"
  >
    <div class="header-inner">
      <div class="menu-items-wrapper">
        <span class="hello-msg"><b>Parking booking system upgrade</b><br>
        Amex payments are currently unavailable. We’re working to fix this as soon as possible. Please use an alternative card in the meantime.<br>
        Customers unable to use an alternate card please visit the office on the station concourse where we will price match online pricing for your stay.
        </span>
      </div>
    </div>
  </div>

  <div
    v-cloak
    v-if="brandSlug === 'SB2' || brandSlug === 'SB3' || brandSlug === 'SB5'"
    class="header-wrapper header-wrapper-hello-msg header-wrapper-hello-msg-sb2"
    :style="set_style_variables"
    style="width: 100%;"
  >
    <div class="header-inner">
      <div class="menu-items-wrapper">
        <span class="hello-msg"><b>Parking booking system upgrade</b><br>
        Amex payments are currently unavailable. We’re working to fix this as soon as possible. Please use an alternative card in the meantime. If you cannot pay online you can still drive up and pay onsite.
        </span>
      </div>
    </div>
  </div> -->

  <div
    class="header-wrapper"
    @mouseleave="leaveUserPanel()"
    :class="[(manage_header_no_toggle ? ` manage-header-perm` : ``), page_classes]"
    :style="set_style_variables"
  >
    <div class="header-inner">
      <div
        @click="gotoPage(logo_link.url, logo_link.mtype)"
        class="ID-logo"
        :class="`ID-logo-${brandSlug}`"
      ></div>
      <div class="menu-items-wrapper">
        <div
          v-if="show_home && brandSlug !== 'SV1'"
          @click="gotoPage(home_link)"
          :class="`menu-item tab-home${
            highlight_tab_item === 1 || highlight_tab_item === '/'
              ? ' tab-active'
              : ''
          }`"
        >
          <i class="fa fa-home" aria-hidden="true"></i>
        </div>

        <template v-for="(item, index) in (header_menu || [])" :key="index">
          <div
            v-if="logged_in && item?.loggedin && item?.label"
            :class="`menu-item menu-item-loop tab-${index + 1}${
              item.label === highlight_tab_item ? ' tab-active' : ''
            }`"
            @click="gotoPage(item.url, item.mtype)"
          >
            {{ getrans(item.label) }}
          </div>
          <div
            v-if="
              !logged_in &&
              item?.loggedout &&
              item?.label &&
              item.label.toLowerCase() == 'login'
            "
            :class="`menu-item menu-item-loop tab-${index + 1}${
              item.label === highlight_tab_item ? ' tab-active' : ''
            }`"
          >
            {{ getrans(item.label) }}
          </div>
          <div
            v-if="
              !logged_in &&
              item?.loggedout &&
              item?.label &&
              item.label.toLowerCase() != 'login'
            "
            :class="`menu-item menu-item-loop tab-${index + 1}${
              item.label === highlight_tab_item ? ' tab-active' : ''
            }`"
            @click="gotoPage(item.url, item.mtype)"
          >
            {{ getrans(item.label) }}
          </div>
          <!-- Fallback for menu items without loggedin/loggedout properties -->
          <div
            v-if="
              item?.label &&
              !item.hasOwnProperty('loggedin') &&
              !item.hasOwnProperty('loggedout')
            "
            :class="`menu-item menu-item-loop tab-${index + 1}${
              item.label === highlight_tab_item ? ' tab-active' : ''
            }`"
            @click="gotoPage(item.url, item.mtype)"
          >
            {{ getrans(item.label) }}
          </div>
        </template>

        <div
          v-if="show_languages"
          @click="show_language_dropdown = !show_language_dropdown"
          class="menu-item menu-item-dropdown-lang tab-lang"
        >
          <span class="lang-text">{{ lang }}</span>
          <div class="lang-flag" :style="flagImage(brandSlug === 'PIT' ? 'us' : lang)"></div>

          <transition name="fade">
            <div
              v-show="show_language_dropdown"
              class="menu-item-dropdown-lang__select"
            >
              <div
                v-for="lng in languages"
                :key="lng"
                class="menu-item-dropdown-lang__select-item"
                @click="changeLang(lng)"
              >
                <div :class="`lang-flag ${lng}`" :style="flagImage(lng)"></div>
                <span>{{ lng.toUpperCase() }}</span>
              </div>
            </div>
          </transition>
        </div>

        <!-- @click="gotoPage('/yourdetails.html')" -->
        <div
          v-if="new_basket_number > 0 && basket_is_model_and_page"
          :class="basket_is_model_and_page"
          class="menu-item tab-basket basket_is_model_and_page_desktop"
          tabindex="0"
          @click="gotoPage('/yourdetails.html')"
        >
          <BasketIcon :basket_number="new_basket_number" />
          <span class="basket-text">{{ getBrandText('basketText', 'Basket') }}</span>
        </div>

        <div
          v-if="new_basket_number > 0 && basket_is_model_and_page"
          :class="basket_is_model_and_page"
          class="menu-item tab-basket basket_is_model_and_page_mobile"
          tabindex="0"
          @click="toggle_basket_model()"
        >
          <BasketIcon :basket_number="new_basket_number" />
          <span class="basket-text">{{ getBrandText('basketText', 'Basket') }}</span>
        </div>

        <div
          v-if="new_basket_number > 0 && !basket_is_model_and_page"
          class="menu-item tab-basket"
          tabindex="0"
          @click="
            basket_is_model
              ? toggle_basket_model()
              : gotoPage('/yourdetails.html')
          "
        >
          <BasketIcon :basket_number="new_basket_number" />
          <span class="basket-text">{{ getBrandText('basketText', 'Basket') }}</span>
        </div>

        <div
          v-if="show_user_is_logged_in"
          :class="`${manage_header ? `manage-header-show` : ``}`"
          class="user-panel"
        >
          <div class="user-panel-new">
            <div class="user-initials">{{ initials }}</div>
            <span class="user-fullname">{{ firstname }} {{ surname }}&nbsp;&nbsp;</span>
          </div>
          <span class="user-logout" @click="logoutsession"
            > <i class="fas fa-sign-out-alt"> </i> {{ getrans("Logout") }}</span
          >
        </div>

        <div
          v-else-if="new_login_modal()"
          :class="`menu-item ${manage_header ? `manage-header-show` : ``}`"
          class="user-panel"
        >
          <span class="user-login" @click="loginsession"
            ><i class="fas fa-user-circle"></i> {{ getrans("Sign in") }}</span
          >
        </div>

        <div
          v-if="header_menu?.length"
          class="menu-item tab-mobile-menu"
          @click="showMobileMenu = !showMobileMenu"
          @focusout="showMobileMenu = false"
          tabindex="0"
        >
          <i class="fa fa-bars"></i>
          <transition name="fade">
            <div v-show="showMobileMenu" class="menu-items_mobile-wrapper">
              <div
                :class="`menu-item-mobile tab-0`"
                @click="gotoPage('/index.html')"
              >
                <span>{{ getBrandText('homeText', getrans("Home")) }}</span
                ><i class="fa fa-chevron-right"></i>
              </div>

              <template v-for="(item, index) in (header_menu || [])" :key="index">
                <div
                  v-if="logged_in && item?.loggedin && item?.label"
                  :class="`menu-item-mobile tab-${index + 1}`"
                  @click="gotoPage(item.url, item.mtype)"
                >
                  <span>{{ getrans(item.label) }}</span
                  ><i class="fa fa-chevron-right"></i>
                </div>

                <div
                  v-if="!logged_in && item?.loggedout && item?.label"
                  :class="`menu-item-mobile tab-${index + 1}`"
                  @click="gotoPage(item.url, item.mtype)"
                >
                  <span>{{ getrans(item.label) }}</span
                  ><i class="fa fa-chevron-right"></i>
                </div>
                
                <!-- Fallback for menu items without loggedin/loggedout properties -->
                <div
                  v-if="
                    item?.label &&
                    !item.hasOwnProperty('loggedin') &&
                    !item.hasOwnProperty('loggedout')
                  "
                  :class="`menu-item-mobile tab-${index + 1}`"
                  @click="gotoPage(item.url, item.mtype)"
                >
                  <span>{{ getrans(item.label) }}</span
                  ><i class="fa fa-chevron-right"></i>
                </div>
              </template>

              <template v-for="(item, index) in (manage_menu || [])" :key="index">
                <div
                  v-if="logged_in && item?.label"
                  :class="`menu-item-mobile tab-${index + 1}-2`"
                  @click="gotoPage(item.url, item.mtype)"
                >
                  <span>{{ getrans(item.label) }}</span
                  ><i class="fa fa-chevron-right"></i>
                </div>
              </template>

              <div
                v-if="show_user_is_logged_in"
                @click="logoutsession"
                :class="`menu-item-mobile tab-logout`"
              >
                <span>{{ getrans("Logout") }}</span
                ><i class="fas fa-sign-out-alt"></i>
              </div>

              <div
                v-else-if="new_login_modal()"
                @click="loginsession"
                :class="`menu-item-mobile tab-logout`"
              >
                <span>{{ getrans("Sign In") }}</span
                ><i class="fas fa-sign-out-alt"></i>
              </div>

              <div class="menu-item-mobile tab-lang" v-if="show_languages">
                <div v-for="lng in languages" :key="lng">
                  <div
                    :class="`lang-flag ${lng}`"
                    :style="flagImage(lng)"
                    @click="changeLang(lng)"
                  ></div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div
      v-if="logged_in"
      :class="`manage-header${manage_header ? ` manage-header-show` : ``}`"
    >
      <div class="manage-header-inner">
        <a
          v-for="(item, index) in manage_menu"
          :key="index"
          :href="item.url"
          :class="`${item.active === manage_active ? 'active' : ''}`"
          >{{ item.text }}</a
        >
        <a v-if="logged_in" @click="logged_in = !logged_in">{{
          getrans("Logout")
        }}</a>
      </div>
    </div>
  </div>
  <Dialog
    header="Please enter your email id to proceed"
    v-model:visible="dialog"
    :style="{ width: '50vw' }"
  >
    <div class="block">
      <label for="emailid">
        {{ "Enter your email address" }}
        <span class="form-mandatory">*</span>
      </label>
      <input
        name="emailid"
        autofocus="autofocus"
        type="text"
        id="emailid"
        data-lpignore="true"
      />
    </div>
    <template #footer>
      <button @click="closeBasic">{{ "Close" }}</button>
      <button @click="closeBasic" autofocus>{{ "Proceed" }}</button>
    </template>
  </Dialog>

  <LoginModelNew :getransfn="getrans" :setbrandid="brandSlug" :lang="lang"/>

  </div>

</template>

<script>
import BasketIcon from "@/components/BasketIcon.vue";
import { useBrand } from '@/composables/useBrand';
import md5 from "js-md5";
import LoginModelNew from "@/components/LoginModelNew.vue";
import { normalizeBrandId } from '@/modules/brandId';

const localforage = require("localforage");
let store = localforage.createInstance({
  name: "tranlations",
});

const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});

import { languagesConfig } from "@/brand/languagesConfig.js"; 

export default {
  name: "Header",
  props: {
    basket_is_model: undefined,
    basket_is_model_and_page: undefined,
    logo_link: undefined,
    home_link: undefined,
    show_home: undefined,
    show_languages: undefined,
    basket_number: undefined,
    manage_header_no_toggle: undefined,
    manage_active: undefined,
    userfirstname: undefined,
    logo_image: undefined,
    header_menu: undefined,
    show_basket: undefined,
    lang: undefined,
    translations: undefined,
    brandSlug: undefined,
    highlight_tab_item: undefined,
    page_classes: undefined
  },
  components: {
    BasketIcon,
    LoginModelNew,
  },
  emits: ["toggleBasket"],
  data() {
    return {
      brandConfig: null,
      show_user_is_logged_in: false,
      new_basket_number: 0,
      show_language_dropdown: false,
      logged_in: false,
      dialog: false,
      manage_header: false,
      showMobileMenu: false,
      showBasket: false,
      showBasketOnHeader: true,
      header_items_data: [
        { url: "/faqs.html", text: "FAQs", loggedin: true, loggedout: true },
        {
          url: "https://myaccount.rezcommdev.com",
          loggedin: true,
          loggedout: true,
          class: "",
          label: "Home",
          mcolumn: "No Columns",
          menusvg: "",
          mgroup: "",
          mid: 149,
          mtype: "Internal",
          position: "T",
        },
      ],
      manage_menu: [
        { url: "/bookings.html", text: "Your Bookings", active: "bookings" },
        { url: "/details.html", text: "Your Details", active: "details" },
        {
          url: "/changepassword.html",
          text: "Change Password",
          active: "changepassword",
        },
      ],
      languages: ["el", "en"],
      firstname: "",
      surname: "",
      initials: "",
      adhoc_cart: undefined,
    };
  },
  computed: {
    set_style_variables: function () {
      return {
        "--logo-image": `url(${this.logo_image})`,
      };
    },
  },
  methods: {
    new_login_modal() {
      if (
        process.env.VUE_APP_NEW_LOGIN_MODAL &&
        JSON.parse(process.env.VUE_APP_NEW_LOGIN_MODAL).includes(
          this.brandSlug
        )
      ) {
        return true;
      }
      return false;
    },
    getBrandText(key, fallback) {
      if (!this.brandConfig) {
        const { getBrandConfiguration } = useBrand();
        this.brandConfig = getBrandConfiguration(this.brandSlug || 'DEFAULT');
      }
      return this.brandConfig?.header?.[key] || fallback;
    },
    hasSpecialFeature(feature) {
      if (!this.brandConfig) {
        const { getBrandConfiguration } = useBrand();
        this.brandConfig = getBrandConfiguration(this.brandSlug || 'DEFAULT');
      }
      return this.brandConfig?.features?.[feature] || false;
    },
    getrans(string) {

      function decodeHTMLEntities(str) {
        if (typeof str !== 'string') return str;
        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
      }
      //Helper to encode HTML entities (for comparison)
      function encodeHTMLEntities(str) {
        if (typeof str !== 'string') return str;
        const txt = document.createElement('textarea');
        txt.textContent = str;
        return txt.innerHTML.replace(/'/g, '&#39;').replace(/"/g, '&quot;');
      }

      string = encodeHTMLEntities(string);

      const brandId = this.brandSlug || 'DEFAULT';
      const lang = this.lang || 'en';
      const s = md5(string);
      const ss = brandId + "-" + lang.toUpperCase() + "-" + s;
      return decodeHTMLEntities(this.translations?.[ss]) || string;
    },
    changeLang(lang) {
      store.setItem("tranlations", null);
      this.setSessionData("language", lang);
      const url = new URL(window.location.href);
      var search_params = url.searchParams;
      search_params.set("lang", lang);
      url.search = search_params.toString();
      var new_url = url.toString();
      window.location = new_url;
    },
    flagImage(lang) {
      try {
        const cleanLang = String(lang).replace(/["']/g, '').toUpperCase();
        return `background-image: url(${require(`../assets/flags/${cleanLang}.png`)});`;
      } catch (error) {
        console.warn(`Flag image not found for language: ${lang}`);
        return 'background-image: url();';
      }
    },

    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },

    openBasic() {
      this.dialog = true;
    },
    closeBasic() {
      this.dialog = false;
    },
    toggleBasket() {
      this.$emit("toggleBasket");
    },
    toggle_basket_model() {
      const new_event = new CustomEvent("basket_model_toggle", {
        detail: {
          data: "toggle",
        },
      });
      window.dispatchEvent(new_event);
    },
    gotoPage(url, type = null) {
      let logKey;
      let mmb_link = encryptStorage.getItem("mmb_link");

      if (mmb_link && url.indexOf(mmb_link) > -1) {
        console.log("enw_log_key", logKey);
        logKey = encryptStorage.getItem("enw_log_key");
      }

      if (location.host == 'laxstaging.rezcomm.com' && url.indexOf('myparking.flylax.com') > -1) {
        logKey = encryptStorage.getItem("enw_log_key");
        url = 'https://laxmanagemyaccountstaging.rezcomm.com/';
      }

      // Append mmb_link as a query parameter
      if (logKey) {
        const urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set("log_key", logKey);
        url = urlObj.toString();
      }

      // Append lang if needed
      if (
        (url.indexOf("myaccountdev.") > -1 || url.indexOf("myaccount.") > -1) &&
        this.lang
      ) {
        const urlObj = new URL(url);
        urlObj.searchParams.set("lang", this.lang);
        url = urlObj.toString();
      }

      // Redirect or open in new tab
      if (type && type.toLowerCase() === "external") {
        window.open(url);
      } else {
        window.location.href = url;
      }
    },
    enterUserPanel() {
      if (!this.manage_header_no_toggle) {
        this.manage_header = true;
      }
    },
    leaveUserPanel() {
      if (!this.manage_header_no_toggle) {
        this.manage_header = false;
      }
    },
    toggleUserPanel() {
      if (!this.manage_header_no_toggle) {
        this.manage_header = !this.manage_header;
      }
    },

    async check_for_session() {
      console.log('[HEADER DEBUG] check_for_session() called');
      console.log('[HEADER DEBUG] brandSlug:', this.brandSlug);
      
      try {
        const apiProxy = (await import("@/services/apiProxy")).default;
        console.log('[HEADER DEBUG] Calling session_validate API...');
        
        const isLoggedIn = await apiProxy.call('session_validate', { brand_id: normalizeBrandId(this.brandSlug) });
        console.log('[HEADER DEBUG] session_validate response:', isLoggedIn);
        
        if (isLoggedIn && isLoggedIn.valid && isLoggedIn.authenticated) {
          console.log('[HEADER DEBUG] Session is valid - verifying user details for brand');
          const loginEmail = isLoggedIn?.user_data?.email || null;
          const fetched = await this.fetchAndStoreUserDetails(loginEmail);
          if (!fetched) {
            console.log('[HEADER DEBUG] Failed to fetch user details - using session_validate fallback');
            if (isLoggedIn?.user_data) {
              this.updateUserData({
                ...isLoggedIn.user_data,
                slug: normalizeBrandId(this.brandSlug),
              });
            } else {
              this.show_user_is_logged_in = true;
              this.logged_in = true;
            }
          }
        } else {
          console.log('[HEADER DEBUG] Session validation failed - attempting restore');
          const restored = await this.trySessionRestore();
          if (!restored) {
            console.log('[HEADER DEBUG] Session restore failed - clearing user state');
            this.clearUserState();
          }
        }
      } catch (error) {
        console.error('[HEADER DEBUG] Session validation error:', error);
        const restored = await this.trySessionRestore();
        if (!restored) {
          this.clearUserState();
        }
      }
    },

    async trySessionRestore() {
      try {
        const apiProxy = (await import("@/services/apiProxy")).default;
        const response = await apiProxy.call('session_restore', { brand_id: normalizeBrandId(this.brandSlug) });
        console.log('[HEADER DEBUG] session_restore response (from check_for_session):', response);
        
        if (response && response.authenticated) {
          this.show_user_is_logged_in = true;
          this.logged_in = true;
          const restoreEmail = response?.user_data?.email || null;
          const fetched = await this.fetchAndStoreUserDetails(restoreEmail);
          if (!fetched && response?.user_data) {
            this.updateUserData({
              ...response.user_data,
              slug: normalizeBrandId(this.brandSlug),
            });
          }
          return true;
        }
      } catch (error) {
        console.error('[HEADER DEBUG] Session restore error (from check_for_session):', error);
      }
      return false;
    },

    async checkSessionRestore() {
      console.log('[HEADER DEBUG] checkSessionRestore() called');
      
      try {
        const existingData = encryptStorage.getItem("session_userdata");
        
        if (!existingData || !this.logged_in) {
          console.log("[HEADER DEBUG] Attempting restore (no data or not logged in)");
          await this.trySessionRestore();
        }
      } catch (error) {
        console.error("[HEADER DEBUG] Session restore error:", error);
      }
    },

    async checkRememberedDevice() {
      console.log("[HEADER DEBUG] checkRememberedDevice called");
      
      try {
        const RememberDevice = (await import("@/modules/RememberDevice")).default;
        const deviceData = await RememberDevice.isDeviceRemembered();
        console.log('[HEADER DEBUG] Device check result:', deviceData);
        
        if (deviceData && deviceData.valid) {
          console.log("[HEADER DEBUG] Device is remembered and validated");
          
          if (deviceData.token) {
            console.log("[HEADER DEBUG] Received new session token from device validation");
            document.cookie = `session_id=${deviceData.token}; Path=/; Max-Age=3600; SameSite=Lax`;
            
            const apiProxy = (await import('@/services/apiProxy')).default;
            apiProxy.currentSessionToken = deviceData.token;
          }
          
          console.log('[HEADER DEBUG] Fetching user details...');
          const apiProxy = (await import("@/services/apiProxy")).default;
          const sessionState = await apiProxy.call('session_validate', {
            brand_id: normalizeBrandId(this.brandSlug),
          });
          const loginEmail = sessionState?.valid && sessionState?.authenticated
            ? sessionState?.user_data?.email || null
            : null;
          await this.fetchAndStoreUserDetails(loginEmail);
        } else {
          console.log("[HEADER DEBUG] Device not remembered or invalid");
        }
      } catch (error) {
        console.error("[HEADER DEBUG] Remember device check failed:", error);
      }
    },

    async fetchAndStoreUserDetails(loginEmail = null) {
      console.log('[HEADER DEBUG] fetchAndStoreUserDetails() called');
      console.log('[HEADER DEBUG] current brandSlug:', this.brandSlug);
      let userdata = encryptStorage.getItem("session_userdata");
      console.log('[HEADER DEBUG] session_userdata (raw):', userdata);
      
      if (userdata && !userdata.slug) {
        console.log('[HEADER DEBUG] session_userdata missing slug, clearing cached data');
        encryptStorage.removeItem("session_userdata");
        userdata = null;
      }

      const normalizedBrandSlug = normalizeBrandId(this.brandSlug);

      if (userdata && userdata.slug && normalizedBrandSlug && userdata.slug !== normalizedBrandSlug) {
        // Brand mismatch - clear stale user data
        console.log('[HEADER DEBUG] session_userdata brand mismatch, clearing:', userdata.slug, '!=', normalizedBrandSlug);
        encryptStorage.removeItem("session_userdata");
        userdata = null;
      }

      const expectedEmail = (loginEmail || "").toLowerCase().trim();

      if (
        userdata &&
        expectedEmail &&
        (userdata.email || "").toLowerCase().trim() === expectedEmail
      ) {
        console.log('[HEADER DEBUG] Using cached session_userdata');
        this.updateUserDisplay(userdata);
        this.show_user_is_logged_in = true;
        this.logged_in = true;
        return true;
      }

      if (userdata && expectedEmail) {
        console.log('[HEADER DEBUG] Cached session_userdata email mismatch, clearing cache');
        encryptStorage.removeItem("session_userdata");
        userdata = null;
      }

      try {
        console.log('[HEADER DEBUG] Fetching user details from user_details API...');
        const apiProxy = (await import("@/services/apiProxy")).default;
        const requestData = loginEmail
          ? { slug: normalizedBrandSlug, email: loginEmail }
          : { slug: normalizedBrandSlug };
        const response = await apiProxy.call("Central User Details", requestData);
        console.log('[HEADER DEBUG] user_details response:', response);
        
        if (response && response.user_exists === "Y" && response.result && response.result.length > 0) {
          const expectedEmail = (loginEmail || "").toLowerCase().trim();
          const records = Array.isArray(response.result) ? response.result : [];
          const selectedUser = expectedEmail
            ? records.find((row) => (row?.email || "").toLowerCase().trim() === expectedEmail)
            : records[0];
          if (!selectedUser) {
            console.log('[HEADER DEBUG] No exact email match found in Central User Details');
            return false;
          }
          const userdata = { ...selectedUser, slug: normalizedBrandSlug };
          console.log('[HEADER DEBUG] Storing complete user data');
          encryptStorage.setItem("session_userdata", userdata);
          this.updateUserDisplay(userdata);
          this.show_user_is_logged_in = true;
          this.logged_in = true;
          
          // Dispatch event to notify other components
          const userDataAvailableEvent = new CustomEvent("userDataAvailable", {
            detail: { userData: userdata }
          });
          window.dispatchEvent(userDataAvailableEvent);
          return true;
        } else {
          console.log('[HEADER DEBUG] No user data found in response');
          console.log('[HEADER DEBUG] user_details response.user_exists:', response?.user_exists);
          console.log('[HEADER DEBUG] user_details response.result length:', response?.result?.length);
          // Do not clear authenticated UI state here; caller can decide fallback.
          return false;
        }
      } catch (error) {
        console.error('[HEADER DEBUG] Error fetching user details:', error);
        return false;
      }
    },

    updateUserData(userdata) {
      encryptStorage.setItem("session_userdata", userdata);
      this.updateUserDisplay(userdata);
      this.show_user_is_logged_in = true;
      this.logged_in = true;
    },

    updateUserDisplay(userdata) {
      this.firstname = decodeURI(userdata.first_name);
      this.surname = decodeURI(userdata.last_name);
      let initial_1 = Array.from(this.firstname)[0];
      let initial_2 = Array.from(this.surname)[0];
      this.initials = (initial_1 ? initial_1 : '') + (initial_2 ? initial_2 : '');
      this.initials = this.initials.toUpperCase();
    },

    clearUserState() {
      console.log('[HEADER DEBUG] clearUserState() called');
      this.show_user_is_logged_in = false;
      this.logged_in = false;
      this.firstname = "";
      this.surname = "";
      this.initials = "";
    },

    checkExistingSessionData() {
      console.log('[HEADER DEBUG] checkExistingSessionData() called');
      
      const existingUserData = encryptStorage.getItem("session_userdata");
      
      if (existingUserData && existingUserData !== "undefined") {
        if (!existingUserData.slug) {
          console.log('[HEADER DEBUG] session_userdata missing slug, clearing cached data');
          encryptStorage.removeItem("session_userdata");
          return;
        }
        // Do not optimistically mark logged-in from cache alone.
        // Header auth state must come from session_validate/session_restore.
        console.log('[HEADER DEBUG] Found cached session data; waiting for server auth validation before display');
      }
    },
    loginsession() {
      const new_event = new CustomEvent("loginModel", {
        detail: {
          data: {},
        },
      });
      window.dispatchEvent(new_event);
    },
    async logoutsession() {
      try {
        // Invalidate server-side session
        const apiProxy = (await import("@/services/apiProxy")).default;
        await apiProxy.call('logout_session', {});
      } catch (error) {
        console.log("Error invalidating server session:", error);
      }
      
      try {
        // Clean up remember device - await the invalidation
        const RememberDevice = (await import("@/modules/RememberDevice")).default;
        await RememberDevice.forgetDevice();
      } catch (error) {
        console.log("Error cleaning up remember device:", error);
      }
      
      // Clear all client-side storage
      sessionStorage.clear();
      localStorage.clear();
      
      // Clear cookies - specifically target session_id and all other cookies
      // Clear session_id for all possible domains
      const domains = [window.location.hostname, `.${window.location.hostname}`];
      domains.forEach(domain => {
        document.cookie = `session_id=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;
        document.cookie = `remember_device=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;
      });
      
      // Clear all other cookies
      document.cookie.split(";").forEach(cookie => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        if (name) {
          // Clear for current domain and parent domain
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
          domains.forEach(domain => {
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;
          });
        }
      });
      
      window.location = '/index.html';
    },

    setBasketNumber() {
      this.new_basket_number = 0;
      if (sessionStorage.getItem("cart")) {
        this.new_basket_number++;
      }
      if (sessionStorage.getItem("fasttrack_cart")) {
        let fasttrack_cart = encryptStorage.getItem("fasttrack_cart");
        if (Array.isArray(fasttrack_cart)) {
          this.new_basket_number += fasttrack_cart.length;
        } else {
          this.new_basket_number++;
        }
      }
      if (sessionStorage.getItem("lounge_cart")) {
        this.new_basket_number++;
      }
      if (sessionStorage.getItem("coach_cart")) {
        this.new_basket_number++;
      }
      if (sessionStorage.getItem("adhoc_cart")) {
        let adhoc_cart = encryptStorage.getItem("adhoc_cart");
        if (typeof adhoc_cart !== "undefined") {
          console.log("adhoc_cart_tt", adhoc_cart);
          for (let index = 0; index < adhoc_cart.length; index++) {
            if (Array.isArray(adhoc_cart[index])) {
              adhoc_cart[index].map((item) => {
                if (item.pr_price) {
                  this.new_basket_number++;
                }
              });
            } else {
              if (adhoc_cart[index] !== null) {
                if (adhoc_cart[index] && adhoc_cart[index].pr_price) {
                  this.new_basket_number++;
                }
              }
            }
          }
        }
      }
      if (sessionStorage.getItem("adhoc_lounge_cart")) {
        let adhoc_lounge_cart = encryptStorage.getItem("adhoc_lounge_cart");
        /* eslint-disable */
        for (const key in adhoc_lounge_cart) {
          if (adhoc_lounge_cart.hasOwnProperty(key)) {
            for (const item in adhoc_lounge_cart[key]) {
              this.new_basket_number++;
            }
          }
        }
        /* eslint-enable */
      }
    },
    set_langs() {
      const slug = this.brandSlug;
      if (languagesConfig[slug]) {
        this.languages = languagesConfig[slug];
        console.log(this.brandSlug, this.languages);
      }
    },
  },
  async mounted() {
    console.log('[HEADER DEBUG] Header component mounted');
    
    // Initialize brand configuration
    const { getBrandConfiguration } = useBrand();
    this.brandConfig = getBrandConfiguration(this.brandSlug || 'DEFAULT');
    
    // Check for existing session data first
    this.checkExistingSessionData();
    
    // Validate session with server
    await this.check_for_session();
    
    // Check for authenticated session in new tabs
    await this.checkSessionRestore();

    // Check for remembered device only if cookie exists
    const rememberDeviceCookie = this.$cookie?.getCookie("remember_device");
    if (rememberDeviceCookie) {
      await this.checkRememberedDevice();
    }
    
    if (this.manage_header_no_toggle) {
      this.manage_header = true;
    }

    this.setBasketNumber();
    this.set_langs();

    window.addEventListener(
      "update_basket",
      () => {
        this.setBasketNumber();
      },
      false
    );

    window.addEventListener(
      "userLoggedIn",
      async () => {
        console.log('[HEADER DEBUG] userLoggedIn event received');
        await this.check_for_session();
      },
      false
    );

    window.addEventListener(
      "userLoggedOut",
      () => {
        console.log('[HEADER DEBUG] userLoggedOut event received');
        this.clearUserState();
      },
      false
    );
  },
  updated() {
    this.set_langs();
  },
};
</script>

<style scoped lang="scss">
[v-cloak] {
  display: none;
}

@import "@/assets/sass/variables.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.user-panel {
  display: none;
  @media screen and (min-width: 960px) {
    padding: 15px 15px;
    display: flex;
    align-items: center;
    max-height: 56px;
    transition: 0.15s ease-in-out;
    span {
      padding-left: 0.5rem;
      font-weight: bold;
      line-height: 1;
    }
  }
  .user-fullname {
    @media screen and (max-width: 1200px) {
      display: none;
    }
  }

  .user-panel-new {
    background: var(--header_background_color_active, #000);
    color: var(--header_background_color, #fff);
    border-radius: 2rem;
    display: flex;
    justify-content: center;  
    align-items: center;
    padding: 0.333rem;
    .user-initials {
      color : var(--header_background_color_active, #000);
      background: var(--header_background_color, #fff);
      font-weight: bold;
    }
    @media screen and (max-width: 1200px) {
      display: none;
    }
  }

  .user-initials {
    background: var(--header_background_color_active, #000);
    color: var(--header_background_color, #fff);
    width: 2rem;
    height: 2rem;
    border-radius: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .user-logout {
    padding-left: 2rem;
    font-weight: bold;
    cursor: pointer;
    color: var(--header_basket_number_color, #236ca3);
    white-space: nowrap;
  }
}

.user-panel.manage-header-show {
  background: $header-user-bg-hvr;
  color: $header-user-text-hvr;
}

.manage-header.manage-header-show {
  max-height: 60px;
  box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.5);
}

.manage-header-perm .manage-header {
  &.manage-header-show {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
  }

  .manage-header-inner {
    a {
      align-items: center;
      display: flex;
      position: relative;
      height: 100%;
    }
    a.active:after {
      position: absolute;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);
      content: " ";
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 10px 10px 10px;
      border-color: transparent transparent #fff transparent;
    }
  }
}

.manage-header {
  display: none;
  @media screen and (min-width: 960px) {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
    transition: 0.15s ease-in-out;
    max-height: 0px;
    overflow: hidden;
    float: left;
    clear: both;
    margin-top: 0px;
    position: absolute;
    display: flex;
    justify-content: center;
    top: 60px;
    left: 0px;
    right: 0px;
    width: 100%;
    z-index: 99999;
    height: 60px;
    background: $header-manage-bg;
    color: $header-manage-text;
    .manage-header-inner {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      max-width: 1280px;
      width: 100%;
      > * {
        padding: 0px 15px;
      }
      a {
        color: $header-manage-text;
        text-decoration-line: none;
      }
    }
  }
}

.header-wrapper-bhx {
  .icon,
  .button.button--prepend-icon:before,
  .form.form--silverpop input.button--prepend-icon[type="submit"]:before {
    position: relative;
    top: 1px;
    display: inline-block;
    font-family: "icons";
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a .icon,
  a .button.button--prepend-icon:before,
  a .form.form--silverpop input.button--prepend-icon[type="submit"]:before,
  .form.form--silverpop a input.button--prepend-icon[type="submit"]:before {
    display: block;
    margin: 0 auto 10px auto;
    font-size: 32px;
  }

  .icon {
    font-family: "icons-newHeader";
  }

  .icon--airport:before {
    content: "";
  }

  .icon--angle-down:before,
  html.js .slide-panel__navigation ul.top-level > li > a.toggle:before {
    content: "";
  }

  .icon--angle-left:before,
  .picker__nav--prev:before {
    content: "";
  }

  .icon--angle-right:before,
  .picker__nav--next:before {
    content: "";
  }

  .icon--angle-up:before {
    content: "";
  }

  .icon--arrivals-departures:before {
    content: "\E006";
  }

  .icon--book-flights:before {
    content: "";
  }

  .icon--circle-o:before {
    content: "";
  }

  .icon--close:before,
  .hero-tools__content .tool .close:before {
    content: "";
  }

  .icon--destinations:before {
    content: "";
  }

  .icon--directions-transport:before {
    content: "";
  }

  .icon--facebook-square:before {
    content: "";
  }

  .icon--facebook:before,
  .button.button--facebook:before,
  .form.form--silverpop input.button--facebook[type="submit"]:before {
    content: "";
  }

  .icon--information:before {
    content: "";
  }

  .icon--navicon:before {
    content: "";
  }

  .icon--parking:before {
    content: "";
  }

  .icon--refresh:before,
  .button--refresh:before {
    content: "";
  }

  .icon--search:before,
  .slide-panel .slide-panel__search form button:before {
    content: "";
  }

  .icon--special-assistance:before {
    content: "";
  }

  .icon--twitter:before,
  .social-feed blockquote:before,
  .button.button--twitter:before,
  .form.form--silverpop input.button--twitter[type="submit"]:before {
    content: "";
  }

  .icon--warning:before {
    content: "";
  }

  .icon--calendar:before {
    content: "";
  }

  .icon--clock:before {
    content: "";
  }

  .icon--download:before,
  .cta-block.cta-block--download:after {
    content: "";
  }

  .icon--google-plus:before,
  .button.button--gplus:before,
  .form.form--silverpop input.button--gplus[type="submit"]:before {
    content: "";
  }

  .icon--youtube-play:before,
  .button.button--youtube:before,
  .form.form--silverpop input.button--youtube[type="submit"]:before {
    content: "";
  }

  .icon--bulb:before {
    content: "";
  }

  .icon--youtube:before {
    content: "";
  }

  .icon--schedule:before {
    content: "";
  }

  .icon--map-marker:before {
    content: "";
  }

  .icon--walking:before {
    content: "";
  }

  .icon--map-marker-label:before {
    content: "";
  }

  .icon--mail:before {
    content: "";
  }

  .icon--bars-restaurants:before {
    content: "";
  }

  .icon--lounges:before {
    content: "";
  }

  .icon--security-customs:before {
    content: "";
  }

  .icon--shopping:before {
    content: "";
  }

  .icon--car:before,
  .parking-content:before {
    content: "";
  }

  .icon--instagram:before,
  .button.button--instagram:before,
  .form.form--silverpop input.button--instagram[type="submit"]:before {
    content: "";
  }

  .icon--destintinations-and-more:before {
    content: "";
  }

  .icon--plane:before {
    content: "";
  }

  .icon--map-pin-car:before {
    content: "";
  }

  .icon--share:before {
    content: "";
  }

  background: rgba(14, 45, 109, 0.09);
  margin: 0;
  padding: 0;
  height: auto;
  @media screen and (max-width: 959px) {
    height: var(--header_height_mobile);
  }
  width: 100%;
  position: relative;
  box-sizing: content-box;
  .bhx-links {
    display: flex;
    text-align: center;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    a {
      padding: 0rem 1rem;
      margin: 0.75rem 0rem;
      line-height: 1.1;
      font-size: 0.825rem;
      color: #0e2d6d;
      height: 100%;
      min-height: 4.5rem;
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      text-decoration: none;
    }
  }

  .header-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    max-width: calc(1280px + 2rem);
    margin: 0 auto;
  }

  .ID-logo {
    background-repeat: no-repeat;
    background-size: contain;
    width: 33%;
    height: 80px;
    max-height: var(--logo_height_desktop);
    @media screen and (max-width: 959px) {
      max-height: var(--logo_height_mobile);
      width: 66%;
    }

    margin: 4px 1rem;
    box-sizing: border-box;
    position: relative;
    background-image: var(--logo-image);
    cursor: pointer;
  }
}

.header-wrapper {
  border-bottom: var(--header_border_bottom, $header-border-bottom);
  background: var(--header_background_color, $header-background);
  margin: 0;
  padding: 0;
  height: var(--header_height_desktop, 80px);
  @media screen and (max-width: 959px) {
    height: var(--header_height_mobile);
  }

  width: 100%;
  position: relative;
  box-sizing: content-box;
  .header-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    max-width: calc(1280px + 2rem);
    margin: 0 auto;
  }

  .ID-logo {
    background-repeat: no-repeat;
    background-size: contain;
    width: 33%;
    height: 100%;
    max-height: var(--logo_height_desktop);
    @media screen and (max-width: 959px) {
      max-height: var(--logo_height_mobile);
      width: 66%;
    }

    margin: 4px 1rem;
    box-sizing: border-box;
    position: relative;
    background-image: var(--logo-image);
    cursor: pointer;
  }
  .menu-items-wrapper {
    color: var(--header_font_color, $header-text-color);
    font-family: var(--header_font_family, $header-text-font);
    font-size: var(--header_font_size, 1rem);
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: auto;
    user-select: none;
    .menu-item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 0.5rem 1rem;
      border-radius: 2rem;
      // border-right: $header-btn-border;
      transition: 0.2s ease-in-out;
      margin-right: 0.5rem;

      white-space: nowrap;

      &.tab-active {
        background: var(--header_background_color_active, #034a94);
        color: var(--header_font_color_active, #034a94);
      }

      &:hover {
        background: var(--header_background_color_hover, $header-btn-hvr-bg);
        color: var(--header_font_color_hover, #034a94);
      }
      // &:first-child {
      //   border-left: $header-btn-border;
      // }
      .fa-home {
        font-size: 20px;
      }
      .lang-text {
        border-radius: 20px;
        padding: 1px 10px;
        background: $header-lang-bg;
        color: $header-lang-text;
        font-family: $header-lang-font;
      }
      .lang-flag {
        width: 32px;
        height: 32px;
      }

      .basket-icon {
        width: 37px;
        height: 38px;
        margin-left: -5px;
      }
      .basket-text {
        display: none;

        // margin-left: 10px;
        // @media screen and (max-width: 1280px) {
        //   display: none;
        // }
      }
      .basket-number {
        position: absolute;
        left: 0px;
        width: 64px;
        text-align: center;
        top: 12px;
        font-weight: bold;
        font-size: 16px;
        color: $header-basket-number;
      }
    }
    .tab-basket {
      padding-left: 10px;
      padding-right: 10px;
      margin-left: 0px;
    }
    .tab-mobile-menu {
      display: none;
    }

    .menu-items_mobile-wrapper {
      position: absolute;
      top: calc(var(--header_height_mobile) + 3px);
      right: 0px;
      display: flex;
      flex-direction: column;
      z-index: 99999;
      background: $header-mobile-bg;
      color: $header-mobile-text;
    }

    .menu-items_mobile-wrapper {
      width: 100%;
      max-width: 320px;
      box-shadow: 0 8px 8px 1px rgba(0, 0, 0, 0.5);
      .menu-item-mobile {
        box-sizing: border-box;
        padding: 15px;
        text-align: left;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .menu-item-mobile.tab-lang {
        padding: 8px 15px;
        justify-content: flex-start;
        display: var(--header_show_langs, flex);
        .lang-flag {
          margin-right: 15px;
        }
      }
    }

    /* header compacting */
    @media screen and (max-width: 959px) {
      .menu-item-loop {
        display: none;
      }
      .tab-mobile-menu {
        padding: 1rem;
        display: flex;
        &:focus {
          outline: none;
        }
      }
    }
  }
}

.menu-items-wrapper .menu-item.tab-home {
  @media screen and (max-width: 959px) {
    display: none;
  }
}

.menu-items-wrapper .menu-item.tab-lang {
  display: var(--header_show_langs, flex);
  @media screen and (max-width: 959px) {
    display: none;
  }
}

.menu-item-dropdown-lang {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  max-height: 40px;

  &__select {
    background: #fff;
    position: absolute;
    top: calc(100% + 0.5rem);
    z-index: 99999;
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 0.5rem;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
  }
  &__select-item {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    font-weight: bold;
    color: var(--header_font_color, #384048);
  }
  &__select-item:hover {
    background: var(--header_background_color_hover, #eee);
    color: var(--header_font_color_hover, #384048);
  }
}

.header-wrapper .menu-items-wrapper {
  .upsell.basket_is_model_and_page_desktop {
    @media screen and (max-width: 1099.98px) {
      display: none;
    }
  }

  .upsell.basket_is_model_and_page_mobile {
    @media screen and (min-width: 1100px) {
      display: none;
    }
  }
}

.ID-logo-BH1.ID-logo-BH1.ID-logo-BH1 {
  @media screen and (min-width: 959px) {
    width: 0px;
    height: 0px;
    overflow: hidden;
  }
}
.header-wrapper-bhx.header-wrapper-bhx {
  @media screen and (max-width: 959.98px) {
    width: 0px;
    height: 0px;
    overflow: hidden;
  }
}

.bhx-search {
  border-left: 1px solid #0e2d6d;
}

.header-wrapper-hello-msg.header-wrapper-hello-msg {
  height: auto;
  background: #ffa500;

  .header-inner {
    width: 100%;
    margin: 0 auto;
    padding: 1rem;
    text-align: center;
    display: block;
  }

  .hello-msg {
    display: block;
    text-align: center;
    width: 100%;
    margin: 0 auto;
    font-weight: bold;
    //color: #fff;

    a {
      font-weight: bold;
      //color: #fff;
      text-decoration: underline;
    }
  }
}

.header-wrapper.header-wrapper-hello-msg.header-wrapper-hello-msg.header-wrapper-hello-msg-rdu {
  background: #00549f;
  span.hello-msg {
    color: #fff !important;
  }
}

.header-wrapper.header-wrapper-hello-msg.header-wrapper-hello-msg.header-wrapper-hello-msg-all {
  background-color: var(--footer_top_background_color, #384048);
  span.hello-msg {
    color: var(--footer_top_text_color, #fff) !important;
  }
}


.header-wrapper.mapsearch {
  .header-inner {
    max-width: 100%;
  }
}

.hide-hello-msg.header-wrapper-hello-msg {
  display: none !important;
}

#app > div > div:nth-child(1) > div.header-wrapper.header-wrapper-hello-msg.header-wrapper-hello-msg-sb2 {
  background-color: var(--footer_top_background_color, #384048);
  span.hello-msg {
    color: var(--footer_top_text_color, #fff) !important;
    font-weight: normal;
  }
}

#app div.header-wrapper.header-wrapper-hello-msg.header-wrapper-hello-msg-sb2 .hello-msg {
  b {
    font-size: 2rem;
  }
  span {
    font-weight: normal !important;
  }
}
</style>

